module.exports = __webpack_public_path__ + "img/weChat.a54e37dc.svg";